<template>
  <app-modal
    v-if="show"
    :maxWidth="maxWidth"
    :maxHeight="maxHeight"
    :isClickMaskClose="false"
    @close="hideModal"
  >
    <div class="attr-memo">
      <h3>{{ title }}</h3>
      <tinymce
        api-key="aewz9o4jkqj7akqq1fk0jxhi5sub7jyxlhiwfhailv6fq3tr"
        id="attr_value_memmo"
        v-model="text"
        :init="{
          height: 500,
          contextmenu: 'link image inserttable | cell row column deletetable',
          contextmenu_never_use_native: true,
          paste_data_images: true,
          link_list: function (success) {
            success(linkList);
          },
          image_list: function (success) {
            success(imageList);
          }
        }"
        :plugins="plugins"
      ></tinymce>
      <!--
      <div v-if="disabledSave" class="attr-memo__error">
        {{ $t("attr_value_memo_requared") }}
      </div>
      -->
      <div class="attr-memo__actions">
        <el-button @click="hideModal">
          {{ $t("attr_value_memo_cancel") }}
        </el-button>

        <el-button type="success" :disabled="disabledSave" @click="save">
          {{ $t("attr_value_memo_save") }}
        </el-button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { STATUS_CANCELED, STATUS_DONE } from "@/domain/status.types";

export default {
  name: "TextEditor",
  components: {
    AppModal: () =>
      import(
        /* webpackChunkName: "appModal" */ "@/components/library.blocks/AppModal.vue"
      ),
    tinymce: () =>
      import(/* webpackChunkName: "tinymce" */ "@tinymce/tinymce-vue")
  },
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    show: {
      type: Boolean,
      default: false
    },
    title: String
  },
  data() {
    return {
      plugins: [
        "advlist autolink lists link image charmap print preview hr anchor pagebreak",
        "searchreplace wordcount visualblocks visualchars code fullscreen",
        "insertdatetime media nonbreaking save table contextmenu directionality",
        "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
      ]
    };
  },
  computed: {
    text: {
      get() {
        return this.$store.state.textEditor.text;
      },
      set(value) {
        this.$store.commit("setTextEditorText", value);
      }
    },
    requaredField() {
      return this.$store.state.textEditor.requaredField;
    },
    disabledSave() {
      return this.text.trim().length === 0;
    },
    imgHostName() {
      let host = window.location.hostname.toUpperCase();
      return host.indexOf("TEST") === -1 && host.indexOf("INTOURIST") > -1
        ? "https://st.intourist.com"
        : "https://testwd.intourist.com";
    },
    linkList() {
      return this.$store.state.textEditor.linkList.map(item => {
        return {
          title: item.title,
          value: `${this.imgHostName}${item.value}`
        };
      });
    },
    imageList() {
      return this.$store.state.textEditor.imageList.map(item => {
        return {
          title: item.title,
          value: `${this.imgHostName}${item.value}`
        };
      });
    }
  },
  methods: {
    hideModal() {
      this.$store.commit("setTextEditorStatus", STATUS_CANCELED);
      this.$emit("close");
    },
    save() {
      this.$store.commit("setTextEditorStatus", STATUS_DONE);
      this.$emit("save", this.text);
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.attr-memo {
  width: 100%;
  box-sizing: border-box;
  padding: $component_padding_on_top;

  .attr-memo__actions {
    width: 100%;
    margin-top: $component_padding_on_top;
    text-align: right;
  }

  .attr-memo__error {
    padding-top: $component_padding_on_top;
    color: $danger_color;
    font-size: $main_font_size;
  }
}
</style>
